import Papa from 'papaparse'

const jsonToCSV = (json) => {
  return Papa.unparse(json)
}

export default jsonToCSV
